<script>
import Vue from 'vue';

const ChallengesStatItem = Vue.extend({
  data() {
    return { challenges: 0 };
  },
  async mounted() {
    try {
      const challenges = await this.$ctforge.api.get('/challenges/list');
      this.challenges = challenges.length;
    } catch (e) { /* stats are non-critical */ }
  },
  template: `
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Challenges</p>
        <p class="title">{{ challenges }}</p>
      </div>
    </div>
  `,
});

const SolversStatItem = Vue.extend({
  data() {
    return { submissions: 0 };
  },
  async mounted() {
    try {
      const submissions = await this.$ctforge.api.get('/admin/submissions');
      this.submissions = submissions.filter((s) => s.correct).length;
    } catch (e) { /* stats are non-critical */ }
  },
  template: `
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Submissions</p>
        <p class="title">{{ submissions }}</p>
      </div>
    </div>
  `,
});

// Wrapper that renders multiple root-level elements (Vue 2 functional component)
export default {
  functional: true,
  render(h) {
    return [
      h(ChallengesStatItem),
      h(SolversStatItem),
    ];
  },
};

</script>
